export class Unidad {
	id: String = "";
	nombre: String  = "";
	prefijo: String  = "";
    status: String  = "";
    empresa_id: String = "";
 	usuario_id: String  = "";

	 constructor(data?: IUnidad) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

	init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.nombre = data["nombre"];
            this.prefijo = data["prefijo"];
            this.status = data["status"];
            this.empresa_id = data["empresa_id"];
            this.usuario_id = data["usuario_id"];
		}
    }

    static fromJS(data: any): Unidad {
        let result = new Unidad();
        result.init(data);
        return result;
    }
}

export interface IUnidad {
    id: String;
	nombre: String;
	prefijo: String;
    status: String;
    empresa_id: String;
 	usuario_id: String;
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/unidad.ts